var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9996 8.00139L18.9996 8.00131L19 3.00131L7 3.00033L6.99959 8.00033L5.99959 8.00025C4.33959 8.00011 2.99948 9.34 2.99934 11L2.99885 17L6.99885 17.0003L6.99852 21.0003L18.9985 21.0013L18.9989 17.0013L22.9989 17.0016L22.9993 11.0016C22.9995 9.34164 21.6596 8.00153 19.9996 8.00139ZM8.99984 5.00049L16.9998 5.00115L16.9996 8.00115L8.99959 8.00049L8.99984 5.00049ZM16.9987 19.0011L16.9989 17.0011L16.999 15.0011L8.99902 15.0005L8.99869 19.0005L16.9987 19.0011ZM18.999 15.0013L18.9992 13.0013L6.99918 13.0003L6.99902 15.0003L4.99902 15.0002L4.99934 11.0002C4.99939 10.4502 5.44943 10.0002 5.99943 10.0002L19.9994 10.0014C20.5494 10.0014 20.9994 10.4515 20.9993 11.0015L20.999 15.0015L18.999 15.0013ZM17.9993 11.5012C17.9993 10.9489 18.4471 10.5013 18.9994 10.5013C19.5517 10.5014 19.9993 10.9491 19.9993 11.5014C19.9993 12.0537 19.5515 12.5014 18.9992 12.5013C18.4469 12.5013 17.9993 12.0535 17.9993 11.5012Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint24Px);
export default __webpack_public_path__ + "static/media/print_24px.5b3c2a9c8f1b6b72dfdf85def7cb1162.svg";
export { ForwardRef as ReactComponent };